import { Snackbar, makeStyles } from "@material-ui/core";
import { TextField } from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import $ from "jquery";
import update from "immutability-helper";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Button from "@material-ui/core/Button";
import ProductService from "../../../../../services/ProductService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import UOMService from "../../../../../services/Production/UOMService";
import OperationsService from "../../../../../services/Production/OperationsService";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import BOMService from "../../../../../services/Production/BOMService";
import withLoader from "../../../../../components/layouts/WithLoader";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));
function getSteps() {
  return [
    "Choisir les produits",
    "Informations de l'ordre de production ",
    "Finaliser",
  ];
}

const NewProductionOrder = ({startLoading,stopLoading}) => {
  const navigate = useNavigate();
  const [availableProducts, setAvailableProducts] = useState([]);
  const [uomComposant, setUOMComposant] = useState(0);
  const [productComposantId, setProductComposantId] = useState(0);

  const [quantityComposant, setQuantityComposant] = useState(0);

  const [productTableData, setProductTableData] = useState([]);
  const [productMapById, setProductMapById] = useState([]);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [namePO, setNamePO] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [dateEnd, setDateEnd] = useState("any");

  const [selectedOptionUOMComposant, setSelectedOptionUOMComposants] =
    useState(null);
  const [allProducts, setAllProducts] = useState([{}]);
  const [activeStep, setActiveStep] = useState(0);

  const [
    productComposantSelectPlaceHolder,
    setProductComposantSelectPlaceHolder,
  ] = useState("Choisir...");

  const [uomComposantSelectPlaceHolder, setUOMComposantSelectPlaceHolder] =
    useState("Choisir...");
  const [showProduct, setShowProduct] = useState(false);
  const [allUOM, setAllUOM] = useState([]);
  const [availableUOM, setAvailableUOM] = useState([]);
  const steps = getSteps();
  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });

  useEffect(() => {
    // ProductService.getAllProductsOnPurshaseAndService(
    //   getCurrentUserId(),
    //   1,
    //   2
    // ).then((response) => {
    //   setAvailableProducts(response.data["Allproducts"]);
    // });
    startLoading();
    BOMService.getAllProductsWithBOMForPO(getCurrentUserId(), "ACTIVE").then(
      (response) => {
        setAvailableProducts(response.data["success"]);
      }
    ).catch((error)=>{
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : "+error);
    }).finally(()=>{
      stopLoading();
    });

    UOMService.allUnitOfMesure(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableUOM(response.data.success);

          setAllUOM([]);
          response.data.success.map((element) => {
            setAllUOM((oldArray) => [
              ...oldArray,
              { value: element.id, label: element.code + "-" + element.name },
            ]);
          });
        } else if (response.data.empty) {
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de nomenclature");
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, []);

  useEffect(() => {
    availableProducts &&
      availableProducts.map((element) => {
        let exist = false;
        if (allProducts.length !== 0) {
          for (let index = 0; index < allProducts.length; index++) {
            if (allProducts[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        let codeProduct = "*";
        if (element.productCode !== undefined) {
          codeProduct = element.productCode;
        }
        let barCodeProduct = "*";
        if (element.barcode) {
          barCodeProduct = element.barcode;
        }
        let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
        if (element?.id !== undefined && exist === false) {
          setAllProducts((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: label,
              customElements: element.typeProduct,
            },
          ]);
        }
      });
  }, [availableProducts]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityComposantHandler = (event) => {
    setQuantityComposant(event.target.value);
  };

  const onChangeNamePOHandler = (event) => {
    setNamePO(event.target.value);
  };

  const handleNext = () => {
    if (activeStep === 0 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun composant ");
    } else if (activeStep === 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 1 && dateEnd === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de la date limite est vide ");
    } else if (activeStep === 1 && namePO === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de libellé  est vide ");
    } else if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 2) {
      let POModel = {
        idUser: getCurrentUserId(),
        name: namePO,
        componentList: productTableData,
        scheduledDate: dateEnd,
      };

      console.log(JSON.stringify(POModel));
      onSendQuotationToBackendSystem(POModel);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const onChangeSelectedProductComposant = (selectedOptionn) => {
    setSelectedOption();
    setProductComposantId(selectedOptionn.value);
    setProductComposantSelectPlaceHolder(selectedOptionn.label);
    setShowProduct(true);
  };

  const onChangeSelectedUMOComposant = (selectedOptionn) => {
    setSelectedOptionUOMComposants();
    setUOMComposant(selectedOptionn.value);
    setUOMComposantSelectPlaceHolder(selectedOptionn.label);
  };

  const onSendQuotationToBackendSystem = (BOMModel) => {
    startLoading();
    ProductionOrderService.addProductionOrder(BOMModel)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          localStorage.setItem("idPO", response.data.success.id);
          setTimeout(() => {
            navigate(`/production-orders`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme au niveau de serveur");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      }).finally(()=>{
        stopLoading();
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "uomName",
      text: "Unité de mesure",
      align: "center",
      headerAlign: "center",
    },

    {
      dataField: "idProduct",
      text: "Supprimer",
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      headerStyle: () => {
        return { width: "12%" };
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", productTableData);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct)
          );
        },
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  function productDetail() {
    if (showProduct) {
      return (
        <>
          {" "}
          <div class="row">
            <div className="col-sm-6">
              <div className="form-group">
                <div>
                  <label>Choisir une unité de mesure</label>

                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionUOMComposant}
                    onChange={onChangeSelectedUMOComposant}
                    options={allUOM}
                    placeholder={uomComposantSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label>Quantité</label>
                <input
                  onChange={onChangeQuantityComposantHandler}
                  value={quantityComposant}
                  type="number"
                  min="0"
                  id="quantity"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div className="col-sm-12  text-center">
              <button
                style={{ marginBottom: 20 }}
                className="btn btn-dark"
                onClick={onAddProductToList}
              >
                <i class="fas fa-plus"></i>
                Liste des produits{" "}
              </button>
            </div>
          </div>
        </>
      );
    }
  }

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div class="row">
                  <div className="col-sm-12">
                    <i class="fas fa-triangle-exclamation"></i>
                    Les produits de la liste sont seulement ceux qui ont un BOM
                  </div>
                </div>
                <br />
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>Choisir les produits</label>

                      <div className="input-group">
                        <Select
                          styles={styles}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOption}
                          onChange={onChangeSelectedProductComposant}
                          options={allProducts}
                          placeholder={productComposantSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {productDetail()}

            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columnsWithDelete}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div>
                          <div className="row">
                            <BootstrapTable
                              {...props.baseProps}
                              striped
                              hover
                              condensed
                            />
                          </div>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );

      case 1:
        return (
          <div>
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Libellé</label>
                  <input
                    value={namePO}
                    required="required"
                    onChange={onChangeNamePOHandler}
                    type="text"
                    id="inputClientCompany"
                    className="form-control"
                    placeholder="Saisir..."
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputName">Date limite</label>

                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={dateEnd}
                    onChange={onChangeDateEnd}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const onAddProductToList = (event) => {
    let productRef = null;
    let uomRef = null;

    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.idProduct === productComposantId) {
          indexInDataTable = index;
          exist = true;
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      availableProducts.forEach((element) => {
        if (element.id === productComposantId) {
          let codeProduct = "*";
          if (element.productCode !== undefined) {
            codeProduct = element.productCode;
          }
          let barCodeProduct = "*";
          if (element.barcode) {
            barCodeProduct = element.barcode;
          }
          let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
          productRef = label;
          console.log("productRef", productRef);
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      availableUOM.forEach((element) => {
        if (element.id === uomComposant) {
          uomRef = element.name;
          console.log("uomRef", uomRef);
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (productComposantId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un produit ");
    } else if (quantityComposant === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité du produit doit être supérieur à zéro "
      );
    } else {
      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productComposantId,
            uom: uomComposant,
            uomName: uomRef,
            quantity: quantityComposant,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productComposantId,
            uom: uomComposant,
            uomName: uomRef,
            quantity: quantityComposant,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.uom = uomComposant;
        productUpdateValue.uomName = uomRef;

        productUpdateValue.quantity = quantityComposant;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].uom !== uomComposant) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé l'unité de mesure' :  " + uomRef
          );
        } else if (
          productTableData[indexInDataTable].quantity !== quantityComposant
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la quantité du produit : " + productRef
          );
        }
        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();

    console.log("productTableData ", productTableData);
  };

  function etatInitial() {
    setSelectedOption(null);
    // setProductSelectPlaceHolder("Choisir...");
    // setUnitPrice(0);
    // setQuantity(0);
    // setTva(0);
    // setSelectedOptionMode(null);
    // setPromotionType("pourcentage");
    // setPromotionPercentage(0);
    // setSelectedOptionLot(null);
    // setLotSelectPlaceHolder("Choisir...");
    setShowProduct(false);
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li className="breadcrumb-item">
                  <Link to="/bonsDeCommande" style={{ color: "black" }}>
                    Les ordres de production
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Ajouter
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div class="card-body">
                    <div class="row" style={{ marginTop: 2 }}></div>
                    Toutes les étape ont complétées avec succès
                    <Button onClick={handleReset} className={classes.button}>
                      Réinitialiser
                    </Button>
                  </div>
                ) : (
                  <div>
                    <div class="card-body">{getStepContent(activeStep)}</div>
                    <div class="card-footer" style={{ marginTop: "1%" }}>
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-light"
                        onClick={handleBack}
                      >
                        Précédent
                      </button>

                      <button class="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1
                          ? "Terminer"
                          : "Suivant"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(NewProductionOrder);
